import { FeatureSwitchKey, PickFeatureSwitchKey } from '@redngapps/shared/env/types';

type PotentialFeatureSwitch = any;

/**
 * FeatureSwitches need to be explicitly enabled per environment. If you want an identifier string to be considered a
 * feature switch and subsequently considered as such, add it to the `featureSwitches` Array.
 */
type EligibleFeatureSwitchKey = PickFeatureSwitchKey<
  | 'akteAttachmentsMail'
  | 'datalossWarningInDatenerfassung'
  | 'deactivateDoctor'
  | 'eigeneRegelnAbrechnung'
  | 'eigeneRegelnAuswertung'
  | 'gruppentherapieDokumentation'
  | 'heilmittelverordnung'
  | 'locations'
  | 'mailClientDienstkennungen'
  | 'mailversandTerminerinnerung'
  | 'muster12'
  | 'muster12Blanko'
  | 'muster13Blanko'
  | 'muster26'
  | 'muster26Blanko'
  | 'muster27'
  | 'muster27Blanko'
  | 'muster7Blanko'
  | 'preProcessVermittlungscode'
  | 'terminbestaetigung'
  | 'terminkalenderV3'
  | 'tiKonfiguration'
>;

export function isFeatureSwitch(identifier: string): identifier is FeatureSwitchKey {
  const featureSwitches: EligibleFeatureSwitchKey[] = [
    'akteAttachmentsMail',
    'datalossWarningInDatenerfassung',
    'deactivateDoctor',
    'eigeneRegelnAbrechnung',
    'eigeneRegelnAuswertung',
    'gruppentherapieDokumentation',
    'heilmittelverordnung',
    'locations',
    'mailClientDienstkennungen',
    'mailversandTerminerinnerung',
    'muster12',
    'muster12Blanko',
    'muster13Blanko',
    'muster26',
    'muster26Blanko',
    'muster27',
    'muster27Blanko',
    'muster7Blanko',
    'preProcessVermittlungscode',
    'terminbestaetigung',
    'terminkalenderV3',
    'tiKonfiguration',
  ];

  return featureSwitches.includes(identifier as PotentialFeatureSwitch);
}
